/*
  Boxxey — logo-upload in het offerteformulier (sections/boxxey-quote-form.liquid).

  Flow (zie boxxey-offerte-app/README.md voor de serverkant):
  1. Elke aanvraag krijgt in de browser een aanvraagnummer (BXY-JJMM-XXXXX),
     dat als contact[Aanvraagnummer] mee de offertemail in gaat.
  2. Logo kiezen/slepen → POST /apps/boxxey/upload/start (Shopify app proxy →
     Cloudflare Worker) → tijdelijk upload-adres van Shopify.
  3. Het bestand gaat rechtstreeks naar Shopify's opslag (met voortgang),
     daarna POST /apps/boxxey/upload/finish → Shopify Files { id, url }.
  4. De link komt in contact[Logo]; bij verzenden stuurt dit script daarnaast
     (keepalive, op de achtergrond) een kopie naar /apps/boxxey/aanvraag voor
     het offerte-record in Shopify. Het gewone contactformulier verzendt
     altijd zelf — mislukt het record, dan komt de mail gewoon aan.
*/
(function () {
  'use strict';

  var ENDPOINT = '/apps/boxxey';
  var MAX_BYTES = 20 * 1024 * 1024; // = Shopify-limiet voor staged uploads (FILE)
  var TYPES = { pdf: 'PDF', ai: 'AI', eps: 'EPS', svg: 'SVG', png: 'PNG', jpg: 'JPG', jpeg: 'JPG' };
  var PREVIEW = { png: true, svg: true, jpg: true, jpeg: true }; // miniatuur tonen in de browser
  var VECTOR = { pdf: true, ai: true, eps: true, svg: true };
  var STORAGE_KEY = 'boxxey-offerte';
  var STORAGE_MAX_AGE = 24 * 60 * 60 * 1000;
  var ID_ALPHABET = 'ABCDEFGHJKLMNPQRSTUVWXYZ23456789'; // geen 0/O/1/I

  var MSG = {
    type: 'Dit bestandstype wordt niet ondersteund. Gebruik PDF, AI, EPS, SVG, PNG of JPG.',
    size: 'Dit bestand is groter dan 20 MB. Heb je een kleinere versie of een vectorbestand?',
    failed: 'Uploaden is niet gelukt. Probeer het opnieuw — of verstuur je aanvraag zonder logo, dan nemen we contact met je op.',
    busy: 'Even geduld — je logo wordt nog geüpload.',
  };

  // --- opslag (overleeft een herlaad bij een formulierfout) ----------------
  function readState() {
    try {
      var s = JSON.parse(sessionStorage.getItem(STORAGE_KEY) || 'null');
      if (s && s.id && Date.now() - s.ts < STORAGE_MAX_AGE) return s;
    } catch (e) {}
    return null;
  }
  function writeState(state) {
    try {
      state.ts = Date.now();
      sessionStorage.setItem(STORAGE_KEY, JSON.stringify(state));
    } catch (e) {}
  }
  function clearState() {
    try {
      sessionStorage.removeItem(STORAGE_KEY);
    } catch (e) {}
  }

  function newRequestId() {
    var d = new Date();
    var yymm = String(d.getFullYear()).slice(2) + String(d.getMonth() + 1).padStart(2, '0');
    var bytes = new Uint8Array(5);
    (window.crypto || window.msCrypto).getRandomValues(bytes);
    var suffix = '';
    for (var i = 0; i < bytes.length; i++) suffix += ID_ALPHABET[bytes[i] % ID_ALPHABET.length];
    return 'BXY-' + yymm + '-' + suffix;
  }

  function extOf(name) {
    var m = /\.([a-z0-9]+)$/i.exec(name || '');
    return m ? m[1].toLowerCase() : '';
  }

  function formatSize(bytes) {
    if (bytes >= 1024 * 1024) return (bytes / (1024 * 1024)).toFixed(1).replace('.', ',') + ' MB';
    return Math.max(1, Math.round(bytes / 1024)) + ' kB';
  }

  function postJson(path, body) {
    return fetch(ENDPOINT + path, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body),
      credentials: 'same-origin',
    }).then(function (res) {
      return res
        .json()
        .catch(function () {
          return {};
        })
        .then(function (data) {
          if (!res.ok || !data.ok) {
            // Alleen meldingen van onze eigen server tonen we letterlijk aan de klant.
            var err = new Error(data.error || MSG.failed);
            err.fromServer = Boolean(data.error);
            throw err;
          }
          return data;
        });
    });
  }

  // Rechtstreeks naar Shopify's staged-upload-adres; XHR i.p.v. fetch voor voortgang.
  // PNG/JPG gaan als echte zip (zonder compressie) naar Shopify, zodat het origineel
  // byte-identiek bewaard blijft — Shopify's CDN optimaliseert losse afbeeldingen
  // (JPG → WebP). Zip-schrijver: assets/boxxey-zip.js. Vectorbestanden gaan ongewijzigd.
  var ZIPPED = { png: true, jpg: true, jpeg: true };

  // Naam ín de zip: zonder accenten/speciale tekens, zodat elk uitpakprogramma hem goed
  // leest. De originele naam blijft zichtbaar in de mail (Logo-bestand) en op het scherm.
  function zipEntryName(name) {
    var safe = String(name)
      .normalize('NFKD')
      .replace(/[̀-ͯ]/g, '')
      .replace(/[^\x20-\x7e]/g, '_')
      .replace(/[\\/:*?"<>|]/g, '_')
      .trim();
    return safe.slice(-120) || 'logo';
  }

  // Geeft { body, filename } terug: wat er werkelijk naar Shopify gaat.
  function prepareUpload(file, ext) {
    if (!ZIPPED[ext]) return Promise.resolve({ body: file, filename: file.name });
    var entry = zipEntryName(file.name);
    return file.arrayBuffer().then(function (buffer) {
      var parts = window.BoxxeyZip.storedZipParts(entry, new Uint8Array(buffer), new Date());
      return { body: new Blob(parts, { type: 'application/zip' }), filename: entry + '.zip' };
    });
  }

  function uploadToStaging(target, upload, onProgress) {
    return new Promise(function (resolve, reject) {
      var data = new FormData();
      target.parameters.forEach(function (p) {
        data.append(p.name, p.value);
      });
      data.append('file', upload.body, upload.filename);
      var xhr = new XMLHttpRequest();
      xhr.open('POST', target.url);
      xhr.upload.onprogress = function (e) {
        if (e.lengthComputable) onProgress(e.loaded / e.total);
      };
      xhr.onload = function () {
        if (xhr.status >= 200 && xhr.status < 300) resolve();
        else reject(new Error(MSG.failed));
      };
      xhr.onerror = function () {
        reject(new Error(MSG.failed));
      };
      xhr.send(data);
    });
  }

  function showConfirmation(form, sent) {
    var ref = form.querySelector('[data-request-reference]');
    if (!ref || !sent || !sent.id) return;
    ref.querySelector('[data-request-reference-id]').textContent = sent.id;
    var logoLine = ref.querySelector('[data-request-reference-logo]');
    if (sent.logo && sent.logo.naam) {
      logoLine.querySelector('strong').textContent = sent.logo.naam;
      logoLine.hidden = false;
    }
    ref.hidden = false;
  }

  function init(root) {
    var form = root.closest('form');
    if (!form) return;

    var q = function (sel) {
      return root.querySelector(sel);
    };
    var input = q('[data-logo-input]');
    var dropzone = q('[data-logo-dropzone]');
    var status = q('[data-logo-status]');
    var thumb = q('[data-logo-thumb]');
    var nameEl = q('[data-logo-name]');
    var detailEl = q('[data-logo-detail]');
    var progressEl = q('[data-logo-progress]');
    var messageEl = q('[data-logo-message]');
    var retryBtn = q('[data-logo-retry]');
    var urlField = q('[data-logo-url]');
    var fileField = q('[data-logo-filename]');
    var idField = form.querySelector('[data-request-id]');

    // Na een geslaagde verzending: aanvraagnummer (en logo) op het bevestigingsscherm
    // tonen, daarna begint de volgende aanvraag met een schone lei.
    if (root.getAttribute('data-posted') === 'true') {
      showConfirmation(form, readState());
      clearState();
    }
    var state = readState() || { id: newRequestId(), logo: null };
    writeState(state);
    if (idField) idField.value = state.id;

    var busy = false;
    var seq = 0;
    var lastFile = null;
    var objectUrl = null;

    function setHidden(logo) {
      urlField.value = logo ? logo.url : '';
      // In de mail: originele naam, en bij afbeeldingen dat het origineel in de zip zit.
      fileField.value = logo ? logo.naam + (logo.zip ? ' (origineel in zip-bestand)' : '') : '';
      // Lege verborgen velden niet meesturen → geen lege "Logo:"-regel in de mail.
      urlField.disabled = !logo;
      fileField.disabled = !logo;
    }

    function showMessage(text, kind) {
      messageEl.textContent = text || '';
      messageEl.hidden = !text;
      messageEl.setAttribute('data-kind', kind || 'error');
    }

    function setThumb(ext, src) {
      thumb.innerHTML = '';
      if (src) {
        var img = document.createElement('img');
        img.src = src;
        img.alt = '';
        thumb.appendChild(img);
      } else {
        var badge = document.createElement('span');
        badge.className = 'quote-boxxey__upload-ext';
        badge.textContent = TYPES[ext] || 'BESTAND';
        thumb.appendChild(badge);
      }
    }

    function render(view, info) {
      info = info || {};
      root.setAttribute('data-state', view);
      dropzone.hidden = view !== 'idle';
      status.hidden = view === 'idle';
      retryBtn.hidden = view !== 'error' || !lastFile;
      if (view === 'idle') return;
      nameEl.textContent = info.naam || '';
      detailEl.textContent = info.detail || '';
      progressEl.style.width = Math.round((info.progress || 0) * 100) + '%';
    }

    // Geslaagd: groen vinkje + "Logo ontvangen" + originele bestandsnaam (zie CSS [data-state="done"]).
    function showDone(logo) {
      var detail = formatSize(logo.size) + (VECTOR[logo.ext] ? ' · Vectorbestand — ideaal voor gravure' : '');
      render('done', { naam: logo.naam, detail: detail, progress: 1 });
      setThumb(logo.ext, objectUrl && PREVIEW[logo.ext] ? objectUrl : null);
      showMessage('');
    }

    function handleFile(file) {
      if (!file) return;
      var ext = extOf(file.name);
      showMessage('');
      if (!TYPES[ext]) return showMessage(MSG.type);
      // De limiet geldt voor wat Shopify ontvangt: bij afbeeldingen origineel + zip-kop (< 1 kB).
      var extra = ZIPPED[ext] && window.BoxxeyZip ? window.BoxxeyZip.overhead(zipEntryName(file.name)) : 0;
      if (file.size + extra > MAX_BYTES) return showMessage(MSG.size);
      if (file.size === 0) return showMessage(MSG.failed);
      if (ZIPPED[ext] && !window.BoxxeyZip) return showMessage(MSG.failed);

      lastFile = file;
      var mySeq = ++seq;
      busy = true;
      setHidden(null);
      if (objectUrl) URL.revokeObjectURL(objectUrl);
      objectUrl = PREVIEW[ext] ? URL.createObjectURL(file) : null;
      setThumb(ext, objectUrl);
      render('uploading', { naam: file.name, detail: 'Uploaden… 0%', progress: 0.02 });

      var stored, upload;
      prepareUpload(file, ext)
        .then(function (prepared) {
          if (mySeq !== seq) return;
          upload = prepared;
          return postJson('/upload/start', { aanvraagnummer: state.id, filename: upload.filename, size: upload.body.size });
        })
        .then(function (data) {
          if (mySeq !== seq) return;
          stored = data;
          return uploadToStaging(data.upload, upload, function (p) {
            if (mySeq !== seq) return;
            render('uploading', { naam: file.name, detail: 'Uploaden… ' + Math.round(p * 100) + '%', progress: 0.05 + p * 0.85 });
          });
        })
        .then(function () {
          if (mySeq !== seq) return;
          render('uploading', { naam: file.name, detail: 'Bestand verwerken…', progress: 0.95 });
          return postJson('/upload/finish', {
            aanvraagnummer: state.id,
            resourceUrl: stored.upload.resourceUrl,
            filename: stored.filename,
          });
        })
        .then(function (data) {
          if (mySeq !== seq) return;
          busy = false;
          var logo = { id: data.file.id, url: data.file.url, naam: file.name, size: file.size, ext: ext, zip: Boolean(ZIPPED[ext]) };
          state.logo = logo;
          writeState(state);
          setHidden(logo);
          showDone(logo);
        })
        .catch(function (err) {
          if (mySeq !== seq) return;
          busy = false;
          render('error', { naam: file.name, detail: 'Niet geüpload', progress: 0 });
          // Browserfouten (bv. "Failed to fetch" bij een netwerkstoring) nooit tonen.
          showMessage(err && err.fromServer ? err.message : MSG.failed);
        });
    }

    function reset() {
      seq++;
      busy = false;
      lastFile = null;
      state.logo = null;
      writeState(state);
      setHidden(null);
      showMessage('');
      if (objectUrl) URL.revokeObjectURL(objectUrl);
      objectUrl = null;
      input.value = '';
      render('idle');
    }

    // --- events -----------------------------------------------------------
    input.addEventListener('change', function () {
      handleFile(input.files && input.files[0]);
      input.value = ''; // zelfde bestand opnieuw kiezen blijft mogelijk
    });

    ['dragenter', 'dragover'].forEach(function (type) {
      dropzone.addEventListener(type, function (e) {
        e.preventDefault();
        root.classList.add('is-dragover');
      });
    });
    ['dragleave', 'dragend', 'drop'].forEach(function (type) {
      dropzone.addEventListener(type, function (e) {
        e.preventDefault();
        if (type !== 'dragleave' || !dropzone.contains(e.relatedTarget)) root.classList.remove('is-dragover');
      });
    });
    dropzone.addEventListener('drop', function (e) {
      handleFile(e.dataTransfer && e.dataTransfer.files && e.dataTransfer.files[0]);
    });

    q('[data-logo-replace]').addEventListener('click', function () {
      input.click();
    });
    q('[data-logo-remove]').addEventListener('click', reset);
    retryBtn.addEventListener('click', function () {
      handleFile(lastFile);
    });

    // Minimaal record (Shopify metaobject) via /apps/boxxey/aanvraag. Alleen de velden
    // die het record gebruikt. keepalive laat het verzoek doorlopen terwijl de pagina
    // naar het contactformulier navigeert. De Worker werkt per aanvraagnummer bij
    // (upsert), dus meerdere aanroepen leveren nooit een dubbel record op.
    var lastRecordSent = '';
    function sendRecord() {
      var field = function (name) {
        var el = form.querySelector('[name="contact[' + name + ']"]');
        return el ? el.value : '';
      };
      var body = JSON.stringify({
        aanvraagnummer: state.id,
        velden: { Bedrijfsnaam: field('Bedrijfsnaam'), email: field('email') },
        logo: state.logo ? { id: state.logo.id } : null,
      });
      if (body === lastRecordSent) return;
      lastRecordSent = body;
      try {
        fetch(ENDPOINT + '/aanvraag', {
          method: 'POST',
          keepalive: true,
          headers: { 'Content-Type': 'application/json' },
          credentials: 'same-origin',
          body: body,
        }).catch(function () {});
      } catch (err) {}
    }

    form.addEventListener('submit', function (e) {
      if (busy) {
        e.preventDefault();
        showMessage(MSG.busy, 'hint');
        root.scrollIntoView({ behavior: 'smooth', block: 'center' });
        return;
      }
      sendRecord();
    });

    // Ook bij de klik op de verzendknop: Shopify's botbeveiliging (hCaptcha) kan de
    // submit onderscheppen en het formulier later zelf versturen, zonder dat het
    // submit-event hierboven nog afgaat. Alleen bij een geldig formulier.
    var submitButton = form.querySelector('[type="submit"]');
    if (submitButton) {
      submitButton.addEventListener('click', function () {
        if (!busy && form.checkValidity()) sendRecord();
      });
    }

    // Herstel na herladen (bv. formulierfout): logo blijft gekoppeld.
    if (state.logo && state.logo.url) {
      setHidden(state.logo);
      showDone(state.logo);
    } else {
      setHidden(null);
      render('idle');
    }
  }

  function boot() {
    document.querySelectorAll('[data-logo-upload]').forEach(init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
